export enum CSS_VARIABLES {
    PRIMARY_TEXT_COLOR = "--primary-text-color",
    BACKGROUND_FORM_COLOR = "--background-form-color",
    PRIMARY_BUTTON_TEXT_COLOR = "--primary-btn-text-color",
    PRIMARY_BUTTON_BACKGROUND_COLOR = "--primary-btn-bg-color",
    PRIMARY_BUTTON_BORDER_COLOR = "--primary-btn-border-color",
    LOGO_ALIGNMENT = "--logo-alignment",
    LOGO_URL = "--logo-url",
    LOGO_MAX_HEIGHT = "--logo-height",
    INSTALLATION_BUTTON_DISPLAY = "--installation-display",
    BOX_SHADOW_PIXEL = "--box-shadow-pixel",
    BORDER_FORM_COLOR = "--border-form-color",
    BACKGROUND_IMAGE_URL = "--background-image-url",
    CONNECTION_IMAGE_URL = "--connection-image-url",
    VOTE_IMAGE_URL = "--vote-image-url",
    BACKGROUND_OPACITY = "--background-opacity",
    UNSELECTED_OPTION_BACKGROUND_COLOR = "--unselected-option-background-color",
}
